import React from 'react';
import { RouteList } from '@/dataroom/ui/common/FeatureLayout/constants';
import useRouter from '@/Framework/hooks/useNextRouter';
import RedactionLayout from '@/dataroom/ui/components/Dataroom/Redaction/RedactionLayout';
import ManagePermissionGroupsLayout
  from '@/dataroom/ui/components/Settings/ManagePermissionGroups/ManagePermissionGroupsLayout';

const mapLayoutComponents = {
  [RouteList.Redaction]: RedactionLayout,
  [RouteList.ManagePermissionGroups]: ManagePermissionGroupsLayout,
  [RouteList.ManageUsers]: ManagePermissionGroupsLayout,
};

interface IProps {
  children: React.ReactNode,
}

const FeatureLayout = ({ children }: IProps) => {
  const { pathname } = useRouter();

  const project = Object.values(RouteList)
    .find((path) => pathname.startsWith(path));

  const LayoutComponent = mapLayoutComponents[project];

  return LayoutComponent
    ? <LayoutComponent>{ children }</LayoutComponent>
    : children;
};

export default FeatureLayout;
